import { ConfirmModal, MoreButton } from '@/components';
import { useId } from '@/hooks';
import { useMessage } from '@/providers';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useDeleteOrganization, useOrganization } from '../../hooks';

export const OrganizationActionsButton: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { openMessage } = useMessage();
  const { id: organizationId } = useId();

  const { mutateAsync: deleteOrganization } = useDeleteOrganization();
  const { data } = useOrganization({ id: organizationId });

  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  if (!data || data.isIntegrated) {
    return null;
  }

  return (
    <>
      <MoreButton
        items={[
          {
            key: 'delete',
            label: t('delete'),
            danger: true,
          },
        ]}
        onClick={({ key }) => {
          switch (key) {
            case 'delete':
              return setOpenConfirmModal(true);
          }
        }}
      />
      <ConfirmModal
        open={openConfirmModal}
        title={t('delete-confirmation')}
        disclaimerText={t('delete-confirmation-disclaimer')}
        onOk={async () => {
          try {
            await deleteOrganization(organizationId);

            await Promise.all([
              openMessage('success', t('message-delete-completed')),
              (async () => {
                navigate('/tenant-manager?activeKey=organizations', {
                  replace: true,
                });
              })(),
            ]);
          } catch {
            await openMessage('error', t('message-delete-failed'));
          }
        }}
        onCancel={() => {
          setOpenConfirmModal(false);
        }}
      />
    </>
  );
};
